import apiSlice from "./ApiSlice";

export const QuestionCategoryApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET ALL QuestionCategory WITH PAGINATION
    getAllQuestionCategoryWithPagination: builder.query({
      providesTags: ["question-category"],
      query: (body) => {
        return {
          url: "/question-category",
          method: "POST",
          body,
        };
      },
    }),

    getAllQuestionCategory: builder.query({
      providesTags: ["question-category"],
      query: () => {
        return {
          url: "/question-category",
          method: "GET",
        };
      },
    }),
    // Add
    addQuestionCategory: builder.mutation({
      invalidatesTags: ["question-category"],
      query: (body) => {
        return {
          url: "/question-category/add",
          method: "POST",
          body,
        };
      },
    }),
    // DELETE
    deleteQuestionCategory: builder.mutation({
      invalidatesTags: ["question-category"],
      query: ({ id }) => {
        return {
          url: `/question-category/${id}`,
          method: "DELETE",
        };
      },
    }),
    // GET QuestionCategory BY ID
    getQuestionCategoryById: builder.query({
      providesTags: ["question-category"],
      query: ({ id }) => {
        return {
          url: `/question-category/${id}`,
          method: "GET",
        };
      },
    }),
    // EDIT
    editQuestionCategory: builder.mutation({
      invalidatesTags: ["question-category"],
      query: ({ body, id }) => {
        return {
          url: `/question-category/${id}`,
          method: "PUT",
          body,
        };
      },
    }),

    // Question Tag query

    getAllQuestionTag: builder.query({
      providesTags: ["question-category"],
      query: () => {
        return {
          url: "/question-tag",
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useGetAllQuestionCategoryWithPaginationQuery,
  useAddQuestionCategoryMutation,
  useDeleteQuestionCategoryMutation,
  useEditQuestionCategoryMutation,
  useGetQuestionCategoryByIdQuery,
  useGetAllQuestionCategoryQuery,
  useGetAllQuestionTagQuery
} = QuestionCategoryApi;
